import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapBaseLayer from '../enums/MapBaseLayer';
import MapDrawerLocation from '../enums/MapDrawerLocation';
import MapLocation from '../enums/MapLocation';
import MenuEntryType from '../enums/MenuEntryType';

type logMapBaseLayerTappedParams = {
  entry_menu?: MenuEntryType;
  map_base_layer: MapBaseLayer;
  map_drawer_location?: MapDrawerLocation;
  map_id?: number;
  page?: MapLocation;
  trail_id?: number;
};

/**
 * From the explore map view, the user taps the base map layer via the map layer icon
 * @param params - Attributes to log with the amplitude event
 * @param params.entry_menu - The menu button that was clicked to open the basemap and layer menus.
 * @param params.map_base_layer - A string representing the base layer selected.
 * @param params.map_drawer_location - The drawer tab that the map layer was in.
 * @param params.map_id - The map id of the item the user selected
 * @param params.page - The location of the map where the interaction occurred
 * @param params.trail_id - The trail id of the item the user selected
 */
const logMapBaseLayerTapped = (
  { entry_menu, map_base_layer, map_drawer_location, map_id, page, trail_id }: logMapBaseLayerTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'map base layer tapped',
    {
      'entry menu': entry_menu,
      'map base layer': map_base_layer,
      'map drawer location': map_drawer_location,
      'map id': map_id,
      page,
      'trail id': trail_id
    },
    callback
  );
};

export default logMapBaseLayerTapped;
